/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { GblContext } from "providers/formatter";
import clsx from "clsx";
import { useRedirect, Loading, useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { Box, FormControl, Select, InputLabel, MenuItem, Chip, Tooltip, Typography } from "@material-ui/core";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { getArReceiptSearchList } from "services/accountReceivable";
import { getWorkflowStep } from "services/workflow";
import { getEnumApInvoiceStatus } from "services/enum";
import MuiTranslateTable from "components/MuiTranslateTable";
import ActionMenu from "components/ActionMenu";
import CustomTablePagination from "components/CustomTablePagination";
import DatePickerFormat from "components/DatePickerFormat";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { permissionName } from "utils/constants";
import { addDays, startOfMonth, endOfMonth } from "date-fns";
import ModelUriQueryString from "models/uriQueryString";
import { GetWfStatus } from "utils/options";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  statusDraft: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
  },
  statusNormal: {
    backgroundColor: "#2196f3",
    color: "white",
  },
  statusVoid: {
    backgroundColor: "#e57373",
    color: "white",
  },
  divComment: {
    position: "relative",
    height: "20px",
    width: "140px",
  },
  parentStyle: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    boxSizing: "border-box",
    display: "block",
    width: "100%",
  },
  cellStyleEllipsis: {
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  footerCell: {
    backgroundColor: theme.palette.background.paper,
    borderTop: "2px solid rgba(224, 224, 224, 1)",
    borderBottom: "none",
  },
  stickyFooterCell: {
    position: "sticky",
    bottom: 0,
    zIndex: 100,
    textAlign: "right",
    fontSize: "0.9rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
}));

const List = (props) => {
  const translate = useTranslate();
  const classes = useStyles();
  const { basePath, permissions } = props;

  //initial Value with window.sessionStorage
  const ws = window.sessionStorage;
  let t = localStorage.getItem("Tenant");
  const filterValue =
    ws.getItem("basePath") === basePath && ws.getItem(`${t}_searchDetails`)
      ? JSON.parse(ws.getItem(`${t}_searchDetails`)).filterValue
      : undefined;
  const searchQuery =
    ws.getItem("basePath") === basePath && ws.getItem(`${t}_searchDetails`)
      ? JSON.parse(ws.getItem(`${t}_searchDetails`)).searchQuery
      : undefined;
  const searchResults =
    ws.getItem("basePath") === basePath && ws.getItem(`${t}_searchDetails`)
      ? JSON.parse(ws.getItem(`${t}_searchDetails`)).searchResults
      : undefined;

  const { settingAll, DateToString, ToNumber, NumberFormat, ToMySqlDate } = useContext(GblContext);
  const { SettingClosePeriod } = settingAll;
  const { ClosePeriodAr } = SettingClosePeriod;
  const [Data, setData] = useState(searchResults ? searchResults : undefined);
  const [Paging, setPaging] = useState();
  const [uriQueryString, setUriQueryString] = useState({
    Limit: searchQuery ? searchQuery.Limit : ModelUriQueryString.Limit,
    Page: searchQuery ? searchQuery.Page : ModelUriQueryString.Page,
    OrderBy: searchQuery ? searchQuery.OrderBy : ModelUriQueryString.OrderBy,
    WhereGroupList: searchQuery ? searchQuery.WhereGroupList : ModelUriQueryString.WhereGroupList,
    Exclude: searchQuery ? searchQuery.Exclude : ModelUriQueryString.Exclude,
    WhereRaw: searchQuery ? searchQuery.WhereRaw : ModelUriQueryString.WhereRaw,
    WhereLike: searchQuery ? searchQuery.WhereLike : ModelUriQueryString.WhereLike,
    WhereLikeFields: searchQuery ? searchQuery.WhereLikeFields : ModelUriQueryString.WhereLikeFields,
  });
  const [searchText, setSearchText] = useState(filterValue ? filterValue.searchValue : undefined);
  const [wfSteps, setWfSteps] = useState();
  const [showCheckBox, setShowCheckBox] = useState(false);
  const [wfEnumStatus, setWfEnumStatus] = useState();
  const [loading, setLoading] = useState(true);
  const [optionDate, setOptionDate] = useState(filterValue ? filterValue.optionDate : "Receipt Date");
  const [status, setStatus] = useState("E");
  const [wfStatus, setWfStatus] = useState(
    filterValue ? filterValue.status : localStorage.getItem("defaultWfArReceipt") ?? null
  );
  const [filterDate, setFilterDate] = useState({
    from: filterValue ? new Date(filterValue.filterDate.from) : startOfMonth(addDays(new Date(ClosePeriodAr), 1)),
    to: filterValue ? new Date(filterValue.filterDate.to) : endOfMonth(new Date()),
  });

  const redirect = useRedirect();

  const handleFilterList = (tempWfSteps) => {
    const fromMySqlDate = ToMySqlDate(filterDate.from);
    const toMySqlDate = ToMySqlDate(filterDate.to);
    switch (optionDate) {
      case "Receipt Date":
        uriQueryString.WhereGroupList = [
          {
            AndOr: "And",
            ConditionList: [
              {
                AndOr: "And",
                Field: "RcpthDate",
                Operator: ">=",
                Value: fromMySqlDate,
              },
              {
                AndOr: "And",
                Field: "RcpthDate",
                Operator: "<=",
                Value: toMySqlDate,
              },
            ],
          },
        ];
        break;
      default:
        uriQueryString.WhereGroupList = [
          {
            AndOr: "And",
            ConditionList: [],
          },
        ];
        break;
    }

    uriQueryString.WhereLikeFields = [
      "RcpthSeq",
      "RcptRefNo",
      "DATE_FORMAT(RcpthDate, '%d/%m/%Y')",
      "ArNo",
      "FirstName",
      "LastName",
      "Company",
      "RcptDesc",
      "PayRefNo",
      "concat(FirstName, LastName)",
      "RcpthStatus",
    ];

    const condition = uriQueryString.WhereGroupList[0].ConditionList.find((item) => item.Field === "RcpthStatus");

    switch (status) {
      case "All":
        // if (!condition) {
        //   uriQueryString.WhereGroupList[0].ConditionList.push({
        //     AndOr: "And",
        //     Field: "RcpthStatus",
        //     Operator: "=",
        //     Value: "E",
        //   });
        //   uriQueryString.WhereGroupList[0].ConditionList.push({
        //     AndOr: "Or",
        //     Field: "RcpthStatus",
        //     Operator: "=",
        //     Value: "V",
        //   });
        // }
        break;
      default:
        if (!condition) {
          uriQueryString.WhereGroupList[0].ConditionList.push({
            AndOr: "And",
            Field: "RcpthStatus",
            Operator: "=",
            Value: tempWfSteps
              ? tempWfSteps?.length === parseInt(status)
                ? "E"
                : status
              : wfSteps?.length === parseInt(status)
              ? "E"
              : status,
          });
        }
        break;
    }
  };

  const fetchSearchList = async (uriQueryString) => {
    setLoading(true);
    handleFilterList(uriQueryString.tempWfSteps);
    uriQueryString.Exclude = ["Detail", "UserModified"];
    const { Data, Paging } = await getArReceiptSearchList(uriQueryString);
    if (Data) {
      setData(Data);
      setPaging(Paging);
      setUriQueryString(uriQueryString);
    } else {
      setData([]);
    }
    setLoading(false);
  };

  const fetchWorkflow = async () => {
    const enumData = await getEnumApInvoiceStatus();
    setWfEnumStatus(enumData);
    const { data } = await getWorkflowStep("AR_RECEIPT");
    if (data) {
      const showc = data?.find((item) => item.StepNo === parseInt(status));
      if (showc && data) {
        setShowCheckBox(true);
      } else {
        setShowCheckBox(false);
      }
      setWfSteps(data);
    }
  };

  useEffect(() => {
    const mounted = true;
    fetchWorkflow().then((r) => {
      uriQueryString.tempWfSteps = r;
      fetchSearchList(uriQueryString, mounted);
    });
  }, [uriQueryString, filterDate, optionDate, status]);

  const handleRequestSort = (property, order) => {
    uriQueryString.OrderBy = { [property]: order };
    fetchSearchList(uriQueryString);
  };

  if (loading) return <Loading />;
  if (!Data) return null;

  const handleChangePage = (e, newPage) => {
    uriQueryString.Page = newPage + 1;
    fetchSearchList(uriQueryString);
  };

  const handleChangeRowsPerPage = (e) => {
    const newRowsPerPage = parseInt(e.target.value);
    uriQueryString.Limit = newRowsPerPage;
    fetchSearchList(uriQueryString);
  };

  const handleTableChange = (action, tableState) => {
    if (action === "onSearchClose") {
      //clear window.sessionstorage (when user click close icon)
      ws.clear();
      setSearchText();
      uriQueryString.WhereLike = "";
      fetchSearchList(uriQueryString);
    }
  };

  const columns = [
    {
      name: "RcpthSeq",
      label: " ",
      options: {
        filter: true,
        viewColumns: true,
        customBodyRender: (value) => {
          return (
            <a href={`#${basePath}/${value}/show`}>
              <VisibilityIcon
                fontSize="small"
                color="primary"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  //set window.storage value
                  const filterValueObj = {
                    searchValue: searchText,
                    optionDate: optionDate,
                    status: status,
                    filterDate: filterDate,
                  };
                  ws.setItem("basePath", basePath);
                  ws.setItem(
                    `${t}_searchDetails`,
                    JSON.stringify({
                      filterValue: filterValueObj,
                      searchQuery: uriQueryString,
                      searchDetails: Data,
                    })
                  );
                  redirect("show", basePath, value);
                }}
              />
            </a>
          );
        },
      },
    },
    {
      name: "RcpthDate",
      label: "Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return value ? DateToString(new Date(value)) : null;
        },
      },
    },

    {
      name: "RcptRefNo",
      label: "Rcpt. Ref No.",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "ArNo",
      label: "A/R No.",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "FirstName",
      label: "First Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "LastName",
      label: "Last Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Company",
      label: "Company Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "RcptDesc",
      label: "Description",
      options: {
        customBodyRender: (val) => {
          return (
            <Tooltip title={<p style={{ fontSize: 14 }}>{val}</p>} arrow placement="top">
              <div className={classes.divComment}>
                <div className={classes.parentStyle}>
                  <div className={classes.cellStyleEllipsis}>{val}</div>
                </div>
              </div>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "Amount",
      label: "Total",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "PayType",
      label: "Payment Type",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          return `${value}:${Data[tableMeta.rowIndex].PayTypeDesc}`;
        },
      },
    },
    {
      name: "RcpthStatus",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <Chip
              label={GetWfStatus(wfSteps, wfEnumStatus, value)}
              size="small"
              className={clsx(classes.statusDraft, {
                [classes.statusNormal]: value === "Effective",
                [classes.statusVoid]: value === "Void",
              })}
            />
          );
        },
      },
    },
  ];

  const footerClasses = clsx({
    [classes.footerCell]: true,
    [classes.stickyFooterCell]: true,
  });

  const options = {
    filter: false, // show the filter icon in the toolbar (true by default)
    responsive: "standard",
    selectableRows: showCheckBox ? "multiple" : "none",
    serverSide: true,
    confirmFilters: true,
    searchText: searchText,
    searchProps: {
      onKeyUp: (e) => {
        if (e.keyCode === 13) {
          setSearchText(e.target.value);
          uriQueryString.WhereLike = `%${e.target.value}%`;
          uriQueryString.WhereLikeFields = [
            "RcptRefNo",
            "DATE_FORMAT(RcpthDate, '%d/%m/%Y')",
            "ArNo",
            "FirstName",
            "LastName",
            "Company",
            "RcptDesc",
            "PayRefNo",
            "concat(FirstName, LastName)",
            "RcpthStatus",
          ];
          uriQueryString.Page = 1;
          fetchSearchList(uriQueryString);
        }
      },
    },
    download: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      return `\uFEFF${buildHead(columns)}${buildBody(data)}`;
    },
    onTableChange: (action, tableState) => handleTableChange(action, tableState),
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    sortOrder: {
      name: Object.keys(uriQueryString.OrderBy)[0],
      direction: Object.values(uriQueryString.OrderBy)[0],
    },
    onColumnSortChange: (changedColumn, direction) => {
      handleRequestSort(changedColumn, direction);
    },
    customTableBodyFooterRender: function (opts) {
      const sumTotal = opts.data.reduce((accu, item) => {
        let Rate = Data[item.dataIndex].CurrRate;
        const s = ToNumber(accu) + ToNumber(item.data[8]) * Rate;
        return NumberFormat(s ?? 0);
      }, 0);
      return (
        <TableFooter className={footerClasses}>
          <TableRow>
            <TableCell className={footerClasses} style={{ textAlign: "center" }} colSpan={showCheckBox ? 9 : 8}>
              {translate("ra.field.Total")}
            </TableCell>
            {opts.columns.map((col, index) => {
              if (col.display === "true") {
                switch (col.name) {
                  case "Amount":
                    return (
                      <TableCell key={index} className={footerClasses}>
                        {sumTotal}
                      </TableCell>
                    );
                  default:
                    return null;
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
    customFooter: () => {
      return (
        <CustomTablePagination
          rowsPerPageOptions={[15, 50, 100]}
          component="div"
          count={Paging?.TotalRecordCount ?? 0}
          rowsPerPage={Paging?.Limit ?? 15}
          page={Paging?.Page ? Paging.Page - 1 : 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      );
    },
  };

  const menuControlProp = [{ name: "Add", fnc: () => redirect("create", basePath) }];

  const CustomFilterList = () => {
    return (
      <>
        <Box display="flex">
          <Box p={1}>
            <FormControl variant="outlined">
              <InputLabel id="viewMode">{translate("ra.field.ViewBy")}</InputLabel>
              <Select
                labelId="viewMode"
                label={translate("ra.field.ViewBy")}
                variant="outlined"
                margin="dense"
                value={optionDate}
                defaultValue={optionDate}
                onChange={(e) => {
                  setUriQueryString({ ...uriQueryString, Page: 1 });
                  setOptionDate(e.target.value);
                }}
              >
                <MenuItem value={"All"}>{translate("ra.field.All")}</MenuItem>
                <MenuItem value={"Receipt Date"}>{translate("ra.field.Receipt Date")}</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {optionDate !== "All" && (
            <Box p={1}>
              <DatePickerFormat
                label={translate("ra.field.From")}
                value={filterDate.from}
                onChange={(e) => {
                  setUriQueryString({ ...uriQueryString, Page: 1 });
                  setFilterDate((state) => ({
                    ...state,
                    from: e,
                    to: e > filterDate.to ? e : filterDate.to,
                  }));
                }}
                style={{ width: 160, margin: "0 10px" }}
              />
              <DatePickerFormat
                label={translate("ra.field.To")}
                value={filterDate.to}
                onChange={(e) => {
                  setUriQueryString({ ...uriQueryString, Page: 1 });
                  setFilterDate((state) => ({
                    ...state,
                    to: e,
                  }));
                }}
                minDate={filterDate.from}
                minDateMessage={"Date must be more than from date"}
                style={{ width: 160, margin: "0 10px" }}
              />
            </Box>
          )}
          <Box p={1}>
            <FormControl variant="outlined">
              <InputLabel id="status">{translate("ra.field.Status")}</InputLabel>
              <Select
                variant="outlined"
                margin="dense"
                labelId="status"
                label={translate("ra.field.Status")}
                value={status}
                onChange={(e) => {
                  setUriQueryString({ ...uriQueryString, Page: 1 });
                  const showc = wfSteps?.find((item) => item.StepNo === parseInt(e.target.value));
                  if (showc && wfSteps) {
                    setShowCheckBox(true);
                  } else {
                    setShowCheckBox(false);
                  }
                  setStatus(e.target.value);
                  setWfStatus(null);
                }}
                style={{ width: 160 }}
              >
                <MenuItem key={"All"} value={"All"}>
                  {translate("ra.field.All")}
                </MenuItem>
                <MenuItem key={"E"} value={"E"}>
                  {translate("ra.actionMenu.Effective")}
                </MenuItem>
                <MenuItem key={"V"} value={"V"}>
                  {translate("ra.actionMenu.Void")}
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>

        {wfSteps?.length > 0 ? (
          <Typography variant="h6" gutterBottom style={{ marginLeft: 18, marginTop: 4, marginBottom: 0 }}>
            Workflow
          </Typography>
        ) : null}
        <Box display="flex">
          {wfSteps?.map((item, idx) => (
            <Box p={1} key={idx}>
              <Chip
                clickable
                variant={item.StepName === wfStatus ? "default" : "outlined"}
                color={item.StepName === wfStatus ? "primary" : "default"}
                value={item.StepNo?.toString()}
                label={item.StepName}
                onClick={(e) => {
                  setUriQueryString({ ...uriQueryString, Page: 1 });
                  setWfStatus(e.target.outerText);
                  setStatus(item.StepNo);
                }}
              />
            </Box>
          ))}
        </Box>
      </>
    );
  };

  return (
    <div className={classes.root}>
      <ActionMenu
        menuControl={menuControlProp}
        permission={permissions.find((i) => i.Name === permissionName["AR.Receipt"])}
      />
      <MuiTranslateTable
        title={"A/R Receipt"}
        data={Data}
        columns={columns}
        options={options}
        components={{
          TableFilterList: CustomFilterList,
        }}
      />
    </div>
  );
};

export default List;
